import { useForm } from '@mantine/form';

type PrefillConfigFormValues = {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  phoneRegionCode: string;
  country: string;
  stateOrProvince: string;
  monthlyRevenue: number | '';
  companyName: string;
  primaryStoreUrl: string;
  dateOfIncorporation: Date | null;
};

export const PREFILL_CONFIG_KEY = 'prefill-config';

export const defaultValues: PrefillConfigFormValues = {
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
  phoneRegionCode: '',
  country: '',
  stateOrProvince: '',
  monthlyRevenue: '',
  companyName: '',
  primaryStoreUrl: '',
  dateOfIncorporation: null,
};

const getInitialValues = (): PrefillConfigFormValues => {
  try {
    const raw = localStorage.getItem(PREFILL_CONFIG_KEY);
    if (!raw) return defaultValues;
    const parsed = JSON.parse(raw);
    return {
      firstName: parsed.firstName ?? '',
      lastName: parsed.lastName ?? '',
      email: parsed.email ?? '',
      phoneNumber: parsed.phoneNumber?.number ?? '',
      phoneRegionCode: parsed.phoneNumber?.regionCode ?? '',
      country: parsed.country ?? '',
      stateOrProvince: parsed.stateOrProvince ?? '',
      monthlyRevenue: parsed.monthlyRevenue ?? '',
      companyName: parsed.companyName ?? '',
      primaryStoreUrl: parsed.primaryStoreUrl ?? '',
      dateOfIncorporation: parsed.dateOfIncorporation ? new Date(parsed.dateOfIncorporation) : null,
    };
  } catch (e) {
    console.warn('[PrefillConfig] Failed to load saved config from localStorage:', e);
    return defaultValues;
  }
};

export const usePrefillConfigForm = () =>
  useForm<PrefillConfigFormValues>({
    initialValues: getInitialValues(),
    validate: {
      phoneNumber: (value, values) => {
        if (value && !values.phoneRegionCode) return 'Region code is required with phone number';
        return null;
      },
      phoneRegionCode: (value, values) => {
        if (value && !values.phoneNumber) return 'Phone number is required with region code';
        return null;
      },
    },
  });

export type { PrefillConfigFormValues };
